import React from 'react';
import loadable from '@loadable/component';

const PromptForgotPassword = loadable(
  () =>
    import(
      /* webpackChunkName: "PromptForgotPassword.loadable" */ 'app/shared/modules/auth/PromptForgotPasswordV1/component'
    ),
);

interface LoadablePromptForgotPasswordProps {
  showBackLink?: boolean;
}

class LoadablePromptForgotPassword extends React.Component<LoadablePromptForgotPasswordProps> {
  render() {
    return <PromptForgotPassword {...this.props} />;
  }
}

export default LoadablePromptForgotPassword;
